export default "__VITE_ASSET__adc5a9c3__"